import React, { useEffect, useRef } from 'react';
import '../styles/About.css';

const About = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const revealOnScroll = () => {
      const reveals = document.querySelectorAll('.reveal');
      reveals.forEach(element => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < windowHeight - elementVisible) {
          element.classList.add('active');
        }
      });
    };

    const handleParallax = () => {
      if (!sectionRef.current) return;
      const scrolled = window.pageYOffset;
      const rate = scrolled * 0.3;
      const sectionTop = sectionRef.current.offsetTop;
      const sectionHeight = sectionRef.current.offsetHeight;
      const windowHeight = window.innerHeight;

      if (scrolled + windowHeight > sectionTop && scrolled < sectionTop + sectionHeight) {
        const yPos = -(scrolled - sectionTop) * 0.1;
        sectionRef.current.style.transform = `translateY(${yPos}px)`;
      }
    };

    window.addEventListener('scroll', revealOnScroll);
    window.addEventListener('scroll', handleParallax);
    revealOnScroll();

    return () => {
      window.removeEventListener('scroll', revealOnScroll);
      window.removeEventListener('scroll', handleParallax);
    };
  }, []);

  return (
    <section className="about reveal" id="about" ref={sectionRef}>
      <div className="container">
        <div className="about-header">
          <h2 className="section-title">Nice to meet</h2>
          <p className="about-subheading">Ik ben Eva</p>
        </div>
        <div className="about-wrapper">
          <div className="about-content">
            <p className="about-text">
              Ik luister. Ik kijk. Vraag door, vang de echte verhalen en breng ze verder.
            </p>
            <p className="about-text">
              Als senior communicatieadviseur help ik organisaties hun missie en strategie tastbaar en begrijpelijk te maken: intern en extern, voor medewerkers, management en directie. Mijn hart ligt bij corporate communicatie en arbeidsmarktcommunicatie, bij organisaties die ergens voor staan.
            </p>
            <p className="about-text">
              Die ervaring bouwde ik op bij grote corporates en aan bureauzijde, in managementrollen en in teamverband. Het liefst werk ik van binnenuit: als vast onderdeel van een team, betrokken bij het grotere verhaal en met de handen uit de mouwen.
            </p>

          </div>
          <div className="about-image">
            <img src="/images/eva.png" alt="Eva Baris" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;